import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartOptions, ChartType } from 'chart.js';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { DashboardService } from 'src/app/services/dashboard.service';
import { GradientProps } from 'src/app/interfaces/gradient-props';

@Component({
    selector: 'app-common-chart',
    templateUrl: './common-chart.component.html',
    standalone: false
})
export class CommonChartComponent
  extends UnsubscriberComponent
  implements OnInit {
  @Input() public chartSettings: ChartOptions;
  @Input() public chartDataUrl: string;
  @Input() public chartType: ChartType = 'line';
  @Input() public chartGradientProps: GradientProps;
  public chartInstance: Chart;
  public ctx: CanvasRenderingContext2D;
  public total = 0;
  @ViewChild('chart', { read: ElementRef, static: true })
  public chart: ElementRef;

  constructor(private dashboardService: DashboardService) {
    super();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.dashboardService
        .getChartData(this.chartDataUrl)
        .subscribe((data) => {
          this.ctx = this.chart.nativeElement.getContext('2d');
          if (this.chartGradientProps) {
            if (this.chartType === 'line') {
              this.chartSettings.elements.line.backgroundColor = this.generateGradient(
                this.chart,
                this.chartGradientProps
              );
            } else {
              this.chartSettings.elements.bar.backgroundColor = this.generateGradient(
                this.chart,
                this.chartGradientProps
              );
            }
          }
          const chartData = {
            labels: data.label,
            datasets: [],
          };
          delete data.label;
          for (let key in data) {
            if (key.includes('data')) {
              chartData.datasets.push({
                label: '',
                data: data[key],
              });
            }
            if (key === 'total1') {
              this.total = data[key];
            }
          }
          if (chartData.datasets) {
            this.chartInstance = new Chart(this.ctx, {
              data: {
                labels: chartData.labels,
                datasets: chartData.datasets,
              },
              options: this.chartSettings,
              type: this.chartType,
            });
          }
        })
    );
  }

  public generateGradient(
    context: ElementRef,
    gradientProps: GradientProps
  ): CanvasGradient {
    const ctx = context.nativeElement.getContext('2d');
    const gradientFill = ctx.createLinearGradient(...gradientProps.points);
    gradientProps.settings.forEach((point) => {
      gradientFill.addColorStop(point.offset, point.color);
    });
    return gradientFill;
  }
}
